export default __webpack_public_path__ + "static/media/Kobenhavn.71d869c3.ttf";